import { useCallback } from 'react'
import { handleError } from 'src/fixtures/utils/error'
import useSWR from 'swr'
import { nocoSDK } from '../initialize'
import { SWRCachePath } from '../swr-cach-path'
import { useAuthenticate } from '../auth/hooks'
import { UserV1AnnouncementsGetRequest } from '@noco/http-client/lib/noco'

export const useListAnnouncement = (params: UserV1AnnouncementsGetRequest) => {
  const { data: auth } = useAuthenticate()
  const announcementApi = nocoSDK.client?.userService.announcementApi
  const func = useCallback(async () => {
    if (!auth) return
    return await announcementApi
      ?.ApiFactory(auth.token)
      .userV1AnnouncementsGet({ ...params })
      .then(item => {
        return item.data
      })
  }, [auth, announcementApi, params])
  return useSWR(auth && SWRCachePath.listAnnouncement(params), func, {
    onError: err => handleError(err, { tag: 'Get contact list' })
  })
}

export const useGetAnnouncement = (announcementId?: string) => {
  const { data: auth } = useAuthenticate()
  const announcementApi = nocoSDK.client?.userService.announcementApi
  const func = useCallback(async () => {
    if (!auth || !announcementId) return undefined
    return await announcementApi
      ?.ApiFactory(auth.token)
      .userV1AnnouncementsAnnouncementIdGet({ announcementId: announcementId })
      .then(item => {
        return item.data
      })
  }, [auth, announcementApi, announcementId])
  return useSWR(auth && announcementId && SWRCachePath.getAnnouncement(announcementId), func, {
    onError: err => handleError(err, { tag: 'Get contact' })
  })
}

export const useGetLatestAnnouncement = () => {
  const { data: auth } = useAuthenticate()
  const announcementApi = nocoSDK.client?.userService.announcementApi
  const func = useCallback(async () => {
    if (!auth) return undefined
    return await announcementApi
      ?.ApiFactory(auth.token)
      .userV1AnnouncementsLatestGet({})
      .then(item => {
        return item.data
      })
  }, [auth, announcementApi])
  return useSWR(auth && SWRCachePath.getLatestAnnouncement(), func, {
    onError: err => handleError(err, { tag: 'Get contact' })
  })
}
